export const COMPANY = {
  name: "Click World Online",
  tagline: "We Make Brands Click. Online & Beyond.",
  phone1: "+91 73079 58742",
  phone2: "+91 76966 50450",
  email: "info@clickworldonline.com",
  email2: "clickworldindia@gmail.com",
  website: "clickworldonline.com",
  address1: "H.No. 832, Ward No. 08",
  address2: "Mansa, Punjab 151505, India",
  instagram: "https://www.instagram.com/clickworld_online/",
  facebook: "https://www.facebook.com/clickworldonlin/",
  mapsEmbed:
    "https://www.google.com/maps?q=CLICK%20WORLD%20ONLINE%2C%20H.No.%20832%2C%20Ward%20No.%2008%2C%20Mansa%2C%20Punjab%20151505&z=17&output=embed",
  mapsLink: "https://maps.app.goo.gl/rFQMYWTKRnadfvYS6",
  featuredTourEmbed:
    "https://www.google.com/maps/embed?pb=!4v1787317843452!6m8!1m7!1sCAoSHENJQUJJaEEtbnBVaGYzTk9pNmRWRzZCTnlkQVU.!2m2!1d26.1028555837135!2d74.31244724580398!3f173.3720004438813!4f-11.077507252738982!5f0.7820865974627469",
};

export const SERVICES = [
  {
    slug: "digital-marketing-strategy",
    title: "Digital Marketing Strategy",
    short: "A clear digital direction before a single rupee is spent.",
    overview:
      "Every strong result online begins with understanding. We study your business, your audience and your goals, then build a focused digital strategy that decides which channels matter — and which don't.",
    whoFor:
      "Businesses that are investing in digital marketing without a clear plan, or starting their digital journey and want to begin correctly.",
    included: [
      "Business & audience discovery",
      "Competitor and market scan",
      "Channel selection & budgeting",
      "90-day action roadmap",
      "Measurement framework",
    ],
    approach: ["Understand the business first", "Choose tactics that fit the goal", "Measure, learn, refine"],
    benefits: [
      "Every rupee has a purpose",
      "One connected plan across channels",
      "Decisions based on your market, not templates",
      "Clear priorities for your team",
    ],
    related: ["seo", "lead-generation", "social-media-marketing"],
  },
  {
    slug: "seo",
    title: "SEO & Search Visibility",
    short: "Be found when customers are already searching.",
    overview:
      "Search is where buying intent lives. We improve your discoverability through keyword research, on-page and technical optimisation, content and local SEO — built for steady, sustainable visibility.",
    whoFor:
      "Businesses that want to be discovered on Google by customers actively searching for their products or services.",
    included: [
      "Keyword & intent research",
      "On-page optimisation",
      "Technical SEO fixes",
      "Local SEO & Google Business Profile",
      "Content optimisation",
    ],
    approach: ["Research real search demand", "Optimise the website foundation", "Build authority over time"],
    benefits: [
      "Visibility that compounds",
      "Traffic with genuine intent",
      "Stronger local presence",
      "No unrealistic ranking promises — honest work",
    ],
    related: ["keyword-research", "content-creation", "website-design-development"],
  },
  {
    slug: "google-ads",
    title: "Google Ads",
    short: "Capture demand the moment it appears.",
    overview:
      "Google Ads puts your business in front of people searching right now. We plan, build and manage campaigns focused on relevant audiences, quality traffic and enquiries — not vanity clicks.",
    whoFor:
      "Businesses that want immediate, measurable visibility for high-intent searches in their market.",
    included: [
      "Campaign strategy & structure",
      "Keyword & audience targeting",
      "Ad copywriting",
      "Landing experience guidance",
      "Ongoing optimisation & reporting",
    ],
    approach: ["Target intent, not just traffic", "Connect ads to strong landing experiences", "Optimise continuously"],
    benefits: [
      "Immediate search presence",
      "Budget controlled by performance",
      "Clear visibility into enquiries",
      "Campaigns managed by people, not autopilot",
    ],
    related: ["meta-advertising", "lead-generation", "keyword-research"],
  },
  {
    slug: "meta-advertising",
    title: "Meta Advertising",
    short: "Reach the right audience on Facebook & Instagram.",
    overview:
      "Meta platforms are where attention lives. We create advertising campaigns across Facebook and Instagram that combine sharp audience targeting with creative built to stop the scroll.",
    whoFor:
      "Brands that want to build awareness, engagement and enquiries across Facebook and Instagram.",
    included: [
      "Audience research & targeting",
      "Creative direction for ads",
      "Campaign setup & management",
      "Retargeting journeys",
      "Performance reporting",
    ],
    approach: ["Creative built for the feed", "Audiences built from real data", "Test, learn, scale"],
    benefits: [
      "Reach precise local & interest audiences",
      "Creative that fits your brand",
      "Full-funnel campaigns",
      "Transparent reporting",
    ],
    related: ["social-media-marketing", "google-ads", "content-creation"],
  },
  {
    slug: "social-media-marketing",
    title: "Social Media Marketing",
    short: "A consistent presence your audience actually notices.",
    overview:
      "We build social media presence with strategy behind it — content planning, creative production, campaigns and community engagement that keep your brand active and recognisable.",
    whoFor:
      "Businesses that know social media matters but don't have the time, team or system to do it consistently.",
    included: [
      "Social media strategy",
      "Monthly content calendars",
      "Creative posts, reels & stories",
      "Campaign management",
      "Engagement & community care",
    ],
    approach: ["Plan before posting", "Consistency over noise", "Content with a job to do"],
    benefits: [
      "A feed that looks professional",
      "Consistent brand voice",
      "Content tied to business goals",
      "Your time back",
    ],
    related: ["content-creation", "meta-advertising", "branding-creative"],
  },
  {
    slug: "lead-generation",
    title: "Lead Generation",
    short: "Turn interest into real enquiries.",
    overview:
      "Clicks don't grow businesses — conversations do. We design campaigns, landing journeys and follow-up flows built to convert attention into genuine enquiries for your team.",
    whoFor:
      "Businesses that need a predictable flow of enquiries — from service providers to education and retail.",
    included: [
      "Lead campaign strategy",
      "Landing page & form journeys",
      "Ad campaign integration",
      "Lead quality tracking",
      "Follow-up flow guidance",
    ],
    approach: ["Design the full journey", "Remove friction from enquiring", "Track quality, not just quantity"],
    benefits: [
      "Enquiries you can act on",
      "Journeys built for conversion",
      "Clear cost visibility",
      "Sales and marketing aligned",
    ],
    related: ["google-ads", "meta-advertising", "website-design-development"],
  },
  {
    slug: "content-creation",
    title: "Content Creation",
    short: "Words and visuals that make people stop and care.",
    overview:
      "Strong content is the fuel of every channel. We create photography, video, graphics and written content built around your brand and designed for the platforms where your audience lives.",
    whoFor:
      "Brands that need professional, consistent content without building an in-house studio.",
    included: [
      "Content strategy & themes",
      "Graphic design",
      "Photo & video content",
      "Copywriting & captions",
      "Platform-ready formatting",
    ],
    approach: ["Brand first, always", "Made for the platform", "Quality over volume"],
    benefits: [
      "A content library that works hard",
      "Consistent visual identity",
      "Platform-native formats",
      "Faster campaign launches",
    ],
    related: ["social-media-marketing", "branding-creative", "360-virtual-tours"],
  },
  {
    slug: "email-marketing",
    title: "Email Marketing",
    short: "Stay in front of people who already know you.",
    overview:
      "Email remains one of the highest-return channels when done with care. We design and write email campaigns and journeys that keep your audience engaged and bring them back.",
    whoFor:
      "Businesses with an existing audience or customer base they want to nurture and reactivate.",
    included: [
      "Email strategy & planning",
      "Template design",
      "Campaign copywriting",
      "List segmentation guidance",
      "Performance review",
    ],
    approach: ["Value before promotion", "Right message, right segment", "Consistency builds returns"],
    benefits: [
      "Direct line to your audience",
      "Low-cost repeat engagement",
      "Professional design & copy",
      "Measurable results",
    ],
    related: ["lead-generation", "content-creation", "digital-marketing-strategy"],
  },
  {
    slug: "keyword-research",
    title: "Keyword Research",
    short: "Know exactly what your customers are typing.",
    overview:
      "Keyword research is the foundation of SEO and paid search. We map the real language your customers use — search volumes, intent and difficulty — so every campaign targets terms that matter.",
    whoFor:
      "Businesses starting SEO or Google Ads, or those whose current targeting feels like guesswork.",
    included: [
      "Search demand mapping",
      "Intent classification",
      "Competitor keyword gaps",
      "Local search terms",
      "Prioritised target list",
    ],
    approach: ["Start from customer language", "Balance volume with intent", "Prioritise winnable terms"],
    benefits: [
      "No more guessing",
      "SEO and ads aligned",
      "Local intent captured",
      "A roadmap for content",
    ],
    related: ["seo", "google-ads", "content-creation"],
  },
  {
    slug: "website-design-development",
    title: "Website Design & Development",
    short: "A website built around usability and conversion.",
    overview:
      "Your website is where every channel eventually leads. We design and develop modern, fast, mobile-first websites that look premium and are engineered to turn visitors into enquiries.",
    whoFor:
      "Businesses whose website no longer represents their quality — or who need their first serious one.",
    included: [
      "UX-focused design",
      "Mobile-first development",
      "Speed & performance work",
      "SEO-ready structure",
      "Conversion-focused layouts",
    ],
    approach: ["Design for the visitor's journey", "Performance is non-negotiable", "Every page has a purpose"],
    benefits: [
      "A site you're proud to share",
      "Fast on every device",
      "Built to rank and convert",
      "Easy to grow over time",
    ],
    related: ["seo", "lead-generation", "branding-creative"],
  },
  {
    slug: "branding-creative",
    title: "Branding & Creative Services",
    short: "A brand identity people remember.",
    overview:
      "From logos to complete visual systems, we create brand identities and creative assets that make businesses look established, consistent and worth trusting — online and offline.",
    whoFor:
      "New businesses building an identity, or established ones ready for a professional refresh.",
    included: [
      "Logo & identity design",
      "Brand colour & type systems",
      "Marketing collateral",
      "Social media kits",
      "Creative campaign assets",
    ],
    approach: ["Strategy before aesthetics", "Systems, not one-offs", "Consistency everywhere"],
    benefits: [
      "Instant professional credibility",
      "Consistency across every channel",
      "Assets ready for any campaign",
      "A brand that scales",
    ],
    related: ["content-creation", "social-media-marketing", "website-design-development"],
  },
  {
    slug: "360-virtual-tours",
    title: "360° Photography & Virtual Tours",
    short: "Let customers step inside before they visit.",
    overview:
      "We create immersive 360° photography and Google Street View virtual tours that let customers explore your space from anywhere — building trust before they ever walk through the door.",
    whoFor:
      "Hotels, restaurants, real estate, offices, educational institutions, retail spaces and clinics — any business where the space sells.",
    included: [
      "Professional 360° photography",
      "Google Street View publishing",
      "Virtual tour experiences",
      "Website embeds",
      "Google Maps integration",
    ],
    approach: ["Capture the space at its best", "Publish where people search", "Embed everywhere it matters"],
    benefits: [
      "Stand out on Google Maps",
      "Build trust before the visit",
      "Hundreds of tours published",
      "Immersive content for your website",
    ],
    related: ["content-creation", "seo", "website-design-development"],
  },
  {
    slug: "local-seo",
    title: "Local SEO",
    short: "Own 'near me' searches in your city.",
    overview:
      "Local SEO connects your Google Business Profile, website and reviews into one visibility system — so nearby customers find you first when they're ready to buy.",
    whoFor:
      "Businesses that depend on local customers — shops, clinics, institutes, restaurants and service providers.",
    included: [
      "Google Business Profile management",
      "Local keyword targeting",
      "Citations & listing consistency",
      "Review generation strategy",
      "Local visibility reporting",
    ],
    approach: ["Fix the local foundation first", "Build genuine review momentum", "Report calls and direction requests"],
    benefits: [
      "Visible when locals search",
      "More calls & direction requests",
      "Reviews that build trust",
      "City-specific focus",
    ],
    related: ["google-business-profile", "seo", "website-design-development"],
  },
  {
    slug: "google-business-profile",
    title: "Google Business Profile",
    short: "Your first impression on Google Maps.",
    overview:
      "For local businesses, the Google Business Profile is often seen before the website. We set up, verify, optimise and manage profiles that turn Maps searches into calls, direction requests and walk-ins.",
    whoFor:
      "Any business with a physical location or local service area — from clinics to cafés, institutes to showrooms.",
    included: [
      "Profile setup & verification",
      "Categories, services & hours",
      "Photos & posts management",
      "Review generation flow",
      "Q&A and profile updates",
    ],
    approach: ["Complete every field properly", "Keep the profile active weekly", "Grow genuine reviews"],
    benefits: [
      "Show up on Google Maps",
      "More calls & visits",
      "Trust through real reviews",
      "Practiced on our own 4.7-star profile",
    ],
    related: ["local-seo", "seo", "social-media-marketing"],
  },
  {
    slug: "google-street-view",
    title: "Google Street View Publishing",
    short: "Put your business inside Google Maps.",
    overview:
      "We capture and publish professional 360° imagery directly to Google Street View, so anyone searching Maps can step inside your business before they ever visit.",
    whoFor:
      "Hotels, restaurants, clinics, institutes, showrooms and any business where the space helps sell.",
    included: [
      "On-site 360° photography",
      "Street View publishing",
      "Maps listing integration",
      "Website embeds",
      "Quality checks",
    ],
    approach: ["Shoot the space at its best", "Publish to your Google profile", "Embed everywhere it matters"],
    benefits: [
      "Stand out on Google Maps",
      "Build trust before the visit",
      "400+ tours already published",
      "Visible worldwide, instantly",
    ],
    related: ["360-virtual-tours", "google-business-profile", "content-creation"],
  },
];

export const CLIENTS = [
  {
    slug: "exporter-india",
    name: "Exporter India",
    category: "Digital Marketing",
    blurb:
      "Digital marketing and online visibility support for an export-focused business reaching buyers beyond borders.",
    services: ["Digital Marketing Strategy", "Content Creation", "Social Media Marketing"],
  },
  {
    slug: "global-b2b-mart",
    name: "Global B2B Mart",
    category: "Digital Marketing",
    blurb:
      "Digital presence and lead-focused marketing support for a B2B marketplace connecting businesses.",
    services: ["Digital Marketing Strategy", "Lead Generation", "Content Creation"],
  },
  {
    slug: "class-edutech",
    name: "Class EduTech",
    category: "Social Media & Marketing",
    blurb:
      "Social media and digital campaign support for an education brand helping students move forward.",
    services: ["Social Media Marketing", "Content Creation", "Meta Advertising"],
  },
  {
    slug: "berkowits",
    name: "Berkowits",
    category: "360° Virtual Tours & Digital Marketing",
    blurb:
      "360° virtual tours and digital marketing support for a hair & skin clinic brand — including published Google Street View experiences.",
    services: ["360° Virtual Tours", "Digital Marketing", "Local Visibility"],
  },
  {
    slug: "pml-sd-business-school",
    name: "PML SD Business School",
    category: "Digital Marketing",
    blurb:
      "Digital marketing support for a business school reaching the next generation of professionals.",
    services: ["Digital Marketing Strategy", "Social Media Marketing", "Content Creation"],
  },
  {
    slug: "bis-group-of-institutes",
    name: "BIS Group of Institutes",
    category: "Digital Marketing",
    blurb:
      "Digital presence support for an education group with multiple institutes and programmes.",
    services: ["Digital Marketing Strategy", "Social Media Marketing", "Lead Generation"],
  },
  {
    slug: "dr-sood-mansa",
    name: "Dr. Sood Mansa",
    category: "Local Digital Visibility",
    blurb:
      "Local digital visibility and online presence support for a trusted healthcare practice in Mansa.",
    services: ["Local SEO", "Social Media Marketing", "Digital Presence"],
  },
  {
    slug: "aluminium-works-by-sidhu",
    name: "Aluminium Works by Sidhu",
    category: "Meta Advertising",
    location: "Surrey, British Columbia, Canada",
    blurb:
      "Meta advertising services for an aluminium works business in Surrey, British Columbia — reaching customers in the Canadian market remotely from our India studio.",
    services: ["Meta Advertising"],
  },
  {
    slug: "cs3-photography",
    name: "CS3 Photography",
    category: "360° Virtual Tour Service",
    location: "Casselberry, Florida, USA",
    blurb:
      "360° shoot and virtual tour services delivered for a photography client based in Casselberry, Florida, USA.",
    services: ["360° Virtual Tours", "Google Street View Publishing"],
  },
  {
    slug: "harman-boutique",
    name: "Harman Boutique",
    category: "Client",
    blurb:
      "Harman Boutique — a Click World Online client. Follow their latest collections and work on their official Instagram profile.",
    services: [],
    link: "https://www.instagram.com/harman.boutique?igsh=ZHZzcWl2cGhhZWZ0",
  },
];

export const CLIENT_LOCATIONS = {
  india: [
    "Chandigarh, Chandigarh",
    "Jaipur, Rajasthan",
    "Delhi",
    "Kanpur, Uttar Pradesh",
    "Bangalore, Karnataka",
    "Bhopal, Madhya Pradesh",
    "Kolkata, West Bengal",
    "Jodhpur, Rajasthan",
    "Shimla, Himachal Pradesh",
    "Amritsar, Punjab",
    "Ludhiana, Punjab",
    "Lucknow, Uttar Pradesh",
    "Varanasi, Uttar Pradesh",
  ],
  international: [
    "Surrey, British Columbia, Canada",
    "Brampton, Ontario, Canada",
    "Casselberry, Florida, USA",
    "Kathmandu, Nepal",
  ],
};

export const PROCESS = [
  {
    num: "01",
    title: "Discover",
    text: "We start by understanding your business, your audience and your goals. No assumptions, no templates — the strategy begins with listening.",
  },
  {
    num: "02",
    title: "Strategize",
    text: "Discovery becomes direction. We build a focused digital plan: the right channels, the right message, the right sequence — all tied to real business goals.",
  },
  {
    num: "03",
    title: "Create",
    text: "Campaigns, content, creative assets and digital experiences are developed with craft. Everything is built to look premium and work hard.",
  },
  {
    num: "04",
    title: "Launch & Optimize",
    text: "We launch, monitor and improve. Digital is never finished — we keep refining so performance keeps moving forward.",
  },
];

export const PRINCIPLES = [
  {
    title: "Strategic",
    text: "Every business is different — so no two marketing plans should be the same. We start from your reality, not a recycled template.",
  },
  {
    title: "Creative",
    text: "Strong ideas and well-crafted content help brands stand out in feeds, search results and minds.",
  },
  {
    title: "Adaptive",
    text: "Platforms, audiences and opportunities change constantly. Strategies are built to move with them.",
  },
  {
    title: "Connected",
    text: "Channels work best together. Search, social, ads and content are planned as one system, not separate silos.",
  },
  {
    title: "Growth-Focused",
    text: "The purpose of digital activity is to support real business goals — enquiries, visibility, trust and growth.",
  },
];

export const WA_SERVICE =
  "https://wa.me/917307958742?text=" +
  encodeURIComponent("Hi Click World Online! I'm interested in your digital marketing services and would like to discuss a project for my business.");
export const WA_CAREERS =
  "https://wa.me/917307958742?text=" +
  encodeURIComponent("Hi Click World Online! I'm interested in career and job opportunities with your team. Could you please share any current openings?");

export const REVIEWS = [
  {
    name: "Gurwinder Sandhu",
    meta: "Local Guide · Google Review",
    text: "Awesome work done by team. Fully satisfied. They haven't made a single false commitment.",
  },
  {
    name: "Jyoti Rani",
    meta: "Google Review",
    text: "They are doing excellent work. Awesome service on time. I like it.",
  },
  {
    name: "Aman Kaur",
    meta: "Google Review",
    text: "Amazing service. Well done.",
  },
];

export const RATING = { score: "4.7", count: 20 };

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services", dropdown: true },
  { to: "/portfolio", label: "Work" },
  { to: "/360-experiences", label: "360° Experiences" },
  { to: "/locations", label: "Locations" },
  { to: "/contact", label: "Contact" },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
export const getClient = (slug) => CLIENTS.find((c) => c.slug === slug);
